export default __webpack_public_path__ + "static/media/credit-bedit-card.e497894a.png";